/* Cinematic Sakaya — small reveal/parallax/slideshow runtime
   No dependencies. Respects prefers-reduced-motion. */
(() => {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- Reveal on scroll ----
  const revealEls = document.querySelectorAll('.cs-reveal');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-revealed', 'true');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 }
    );
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.setAttribute('data-revealed', 'true'));
  }

  // ---- Parallax slideshow ----
  document.querySelectorAll('[data-cs-pslide]').forEach((root) => {
    const slides = Array.from(root.querySelectorAll('.cs-pslide__slide'));
    const dots = Array.from(root.querySelectorAll('.cs-pslide__dot'));
    if (slides.length < 2) return;
    const interval = parseInt(root.dataset.interval || '6000', 10);
    let index = 0;
    let timer = null;

    const setActive = (next) => {
      slides[index].setAttribute('data-active', 'false');
      if (dots[index]) dots[index].setAttribute('data-active', 'false');
      index = (next + slides.length) % slides.length;
      slides[index].setAttribute('data-active', 'true');
      if (dots[index]) dots[index].setAttribute('data-active', 'true');
    };

    const start = () => {
      if (reduceMotion) return;
      stop();
      timer = setInterval(() => setActive(index + 1), interval);
    };
    const stop = () => { if (timer) clearInterval(timer); timer = null; };

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => { setActive(i); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    start();
  });

  // ---- Subtle parallax on slide images ----
  if (!reduceMotion) {
    const parallaxImgs = document.querySelectorAll('[data-cs-parallax]');
    if (parallaxImgs.length) {
      let ticking = false;
      const update = () => {
        parallaxImgs.forEach((img) => {
          const rect = img.getBoundingClientRect();
          const vh = window.innerHeight;
          if (rect.bottom < 0 || rect.top > vh) return;
          const depth = parseFloat(img.dataset.csParallax || '0.15');
          const center = rect.top + rect.height / 2 - vh / 2;
          img.style.transform = `translateY(${center * -depth}px)`;
        });
        ticking = false;
      };
      window.addEventListener(
        'scroll',
        () => {
          if (!ticking) {
            window.requestAnimationFrame(update);
            ticking = true;
          }
        },
        { passive: true }
      );
      update();
    }
  }

  // ---- Lazy autoplay video on intersect ----
  const heroVideos = document.querySelectorAll('video[data-cs-hero-video]');
  if (heroVideos.length && 'IntersectionObserver' in window) {
    const vio = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const v = entry.target;
        if (entry.isIntersecting) {
          if (!reduceMotion) v.play().catch(() => {});
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.1 });
    heroVideos.forEach((v) => vio.observe(v));
  }

  // Header transparency + scroll-driven solid switch are handled natively by
  // Prestige (#header-scroll-tracker + .is-solid). The cinematic hero opts in
  // via the [allow-transparent-header] attribute on the section root.
})();
